//Custom.ts =================================================
import "./Util/Prototypes";

import * as Carousel from "./Util/Carousel";
import * as CommunityInfo from "./Widgets/CommunityInfo";
import * as DataTable from "./Util/DataTable";
import * as DrawerMenu from "./Menus/DrawerMenu";
import * as MainMap from "./MainMap";
import * as SalesSearchSettings from "./Sales Search/SalesSearchSettings";
import * as Search from "./Search/Search";
import * as Settings from "./Settings";
import * as Util from "./Util/Util";
import * as Util_App from "./Util/Util_App";

import AttachmentQuery from "@arcgis/core/rest/support/AttachmentQuery";
import Point from "@arcgis/core/geometry/Point";
import * as projection from "@arcgis/core/geometry/projection";
import SpatialReference from "@arcgis/core/geometry/SpatialReference";
import WMTSSublayer from "@arcgis/core/layers/support/WMTSSublayer";

//Set custom hyperlink at the top of the results list.
export function getCustomLinks(layerName: string, feature: __esri.Graphic, fs: __esri.FeatureSet) {
   const vals: string[] = [];
   const urls: string[] = [];
   if (!feature) {
      return { values: vals, urls: urls };
   }

   const fields: __esri.Field[] = fs.fields;
   const atrs: any = feature.attributes;
   let title: string = "";
   let popupSpec: Settings.iPopUpTable;
   let url: string;
   let links: string;
   let pin: string;

   //Get mbr.
   let mbr: __esri.Extent;
   if (feature.geometry && feature.geometry.extent) {
      mbr = feature.geometry.extent;
   }

   //Parcels.
   if (layerName === "Parcels") {
      pin = Util_App.getFieldValueNoCase("PIN", feature, fs) as string;

      let centerPnt: __esri.Point;
      if (mbr) {
         centerPnt = Util_App.getPointInsidePolygon(feature.geometry as __esri.Polygon);
      }

      //QPublic property report.
      vals.Add("Property Report");
      url = "https://qpublic.schneidercorp.com/Application.aspx?AppID=678&LayerID=11365&PageTypeID=4&PageID=11827&Q=994439191&KeyValue=" + pin.replace(/-/g, "");
      urls.Add(url);

      //Community info.
      if (mbr) {
         vals.Add("Community Info");
         url = "js:showCommunityInfo|" + centerPnt.x + "," + centerPnt.y;
         urls.Add(url);
      }

      //Sales search.
      if (Settings.security.accessLevel >= SalesSearchSettings.ss.accessLevel) {
         vals.Add("Sales Search");
         url = "js:showSalesSearch|" + pin;
         urls.Add(url);
      }

      //Tax bill.
      vals.Add("Property Tax Bill");
      url = "https://richmondcountyga.governmentwindow.com/tax.html?parcel=" + pin;
      urls.Add(url);

      //Sales history.
      title = "Sales History";
      popupSpec = Util_App.getDataTableSpec(title);

      if (popupSpec) {
         vals.Add(title);
         url = "js:showDataTable|" + title + "," + pin;
         urls.Add(url);
      }

      //PreBill Mobile Home.
      if (Settings.security.accessLevel >= 14) {
         title = "PreBill MH";
         popupSpec = Util_App.getDataTableSpec(title);

         if (popupSpec) {
            vals.Add(title);
            url = "js:showDataTable|" + title + "," + pin;
            urls.Add(url);
         }
      }

      //Oblique photos. (Pictometry)
      vals.Add("Oblique Photos");

      const outSpatialReference = new SpatialReference({ wkid: 4326 });
      const geom = projection.project(centerPnt, outSpatialReference) as __esri.Point;

      if (Settings.security.accessLevel >= 1) {
         url = Settings.webServerURL + "/PictometryAnalytics" + "?Lat=" + geom.y + "&Lon=" + geom.x;
      } else {
         url = Settings.webServerURL + "/PictometryIPA" + "?Lat=" + geom.y + "&Lon=" + geom.x;
      }

      urls.Add(url);

   } //End if layername parcels.

   //Sales layers.
   if (layerName === "All Sales" || layerName === "Residential" || layerName === "Multi-Family" || layerName === "Mobile Home" || layerName === "Commercial" || layerName === "Farm / Timber" || layerName === "Other") {
      pin = Util_App.getFieldValueNoCase("PIN", feature, fs);

      //Property report.
      vals.Add("Property Report");
      url = "https://qpublic.schneidercorp.com/Application.aspx?AppID=678&LayerID=11365&PageTypeID=4&PageID=11827&Q=994439191&KeyValue=" + pin.replace(/-/g, "");
      urls.Add(url);
   } //End if sales layernames.

   //Attachments.
   //if (layerName === "some_layer") {
   //   const objectId: number = Util_App.getObjectId(feature);
   //   vals.Add("Tif Attachment");
   //   url = "js:showAttachment|" + layerName + "," + objectId;
   //   urls.Add(url);
   //}

   if (vals.length !== urls.length) {
      alert("Error: The number of custom links does not match the number of custom values");
   }
   return { values: vals, urls: urls };
}

//Set custom field value in the results list.
export function getCustomValueFeature(fieldName: string, fieldValue: any, feature: __esri.Graphic, layerName: string, fs: __esri.FeatureSet) {
   //let pin: string;
   let outVal: any = fieldValue;
   let url = "";
   let numAcct: number;
   let pin, links, js, i;
   let fsLinks: string[] = [];
   let caseNo: string;
   let commNo: any;
   //let fields: Util_App.iField[];

   if (fieldName.Equal("Deed")) {
      url = Util_App.getFieldValueNoCase("DeedLink", feature, fs);

      if (url) {
         url = Settings.webServerURL + url;
      } else {
         outVal = "Not available";
      }

   } else if (fieldName.Equal("Plat")) {
      url = Util_App.getFieldValueNoCase("PlatLink", feature, fs);

      if (url) {
         url = Settings.webServerURL + url;
      } else {
         outVal = "Not available";
      }

   } else if (fieldName.Equal("Stormwater_Fee")) {
      numAcct = Util_App.getFieldValueNoCase("swo_accts", feature, fs);

      outVal = Util.formatTextValue(outVal, "Money");
      outVal += ", " + numAcct + " Account";
      if (numAcct !== 1) {
         outVal += "s";
      }
      outVal += ", (706) 821-2300";

   } else if (fieldName.Equal("LocNameES") || fieldName.Equal("LocNameMS") || fieldName.Equal("LocNameHS")) {
      url = Util_App.getFieldValueNoCase("Website", feature, fs);

   } else if (fieldName.Equal("REPNAME1")) {
      url = Util_App.getFieldValueNoCase("Comm_Website", feature, fs);

   } else if (fieldName.Equal("REPNAME2")) {
      url = Util_App.getFieldValueNoCase("Board_Website", feature, fs);

   } else if (fieldName.Equal("Website") && layerName.Equal("Schools")) {
      url = Util_App.getFieldValueNoCase("Website", feature, fs);

   } else if (fieldName.Equal("Website") && layerName.Equal("Fire Stations")) {
      url = Util_App.getFieldValueNoCase("Website", feature, fs);

   } else if (fieldName.Equal("Website") && layerName.Equal("Hospitals")) {
      url = Util_App.getFieldValueNoCase("Website", feature, fs);

   } else if (fieldName.Equal("Website") && layerName.Equal("Facilities")) {
      url = Util_App.getFieldValueNoCase("Website", feature, fs);

   } else if (fieldName.Equal("Website") && layerName.Equal("Parks")) {
      url = Util_App.getFieldValueNoCase("Website", feature, fs);

   } else if (fieldName.Equal("Comm_Website")) {
      url = Util_App.getFieldValueNoCase("Comm_Website", feature, fs);

   } else if (fieldName.Equal("Board_Website")) {
      url = Util_App.getFieldValueNoCase("Board_Website", feature, fs);

   } else if (fieldName.Equal("Website") && layerName.Equal("Voter Precincts")) {
      url = Util_App.getFieldValueNoCase("Website", feature, fs);

   } else if (fieldName.Equal("Website") && layerName.Equal("Voter Precincts - Outline")) {
      url = Util_App.getFieldValueNoCase("Website", feature, fs);

   } else if (fieldName.Equal("DISTRICTURL") && layerName.Equal("Congressional Districts")) {
      url = Util_App.getFieldValueNoCase("DISTRICTURL", feature, fs);

   } else if (fieldName.Equal("DISTRICTURL") && layerName.Equal("Georgia Senate")) {
      url = Util_App.getFieldValueNoCase("DISTRICTURL", feature, fs);

   } else if (fieldName.Equal("DISTRICTURL") && layerName.Equal("Georgia House")) {
      url = Util_App.getFieldValueNoCase("DISTRICTURL", feature, fs);

   } else if (fieldName.Equal("LOMA_Link") && layerName === "Parcels") {
      caseNo = Util_App.getFieldValueNoCase("Case_No", feature, fs);

      if (caseNo !== "") {
         commNo = Util_App.getFieldValueNoCase("CommunityNumber", feature, fs);
         outVal = caseNo;
         url = "https://map1.msc.fema.gov/data/13/L/" + caseNo + "-" + commNo + ".pdf";
      }

   } else if (fieldName.Equal("CASE_NO")) {
      links = Util_App.getFieldValueNoCase("S_LOMR_Link", feature, fs);
      fsLinks = addToLinks("LOMR links", links, fsLinks);

      if (fsLinks.length > 0) {
         links = fsLinks.join(",");
         url = "js:showCarousel|" + links;
      }

   } else if (fieldName.Equal("Elev_Cert_Link")) {
      fsLinks = addToLinks("Elev Cert", fieldValue, fsLinks);

      if (fsLinks.length > 0) {
         links = fsLinks.join(",");
         url = "js:showCarousel|" + links;
         outVal = "ElevCerts";
      }

      //} else if (fieldName.Equal("associated_pins")) {
      //   if (fieldValue !== "") {
      //      outVal = "";
      //      links = fieldValue.split(",");

      //      for (i = 0; i < links.length; i++) {
      //         if (i !== 0) {
      //            outVal += '<br>';
      //         }
      //         pin = links[i].Trim();
      //         url = "js:showDataTable|" + title + "," + pin;
      //      }
      //   }

   } else if (layerName === "Zoning" && fieldName.Equal("Zoning")) {
      caseNo = Util_App.getFieldValueNoCase("ZONING_CAS", feature, fs).trim();
      if (caseNo) {
         outVal += ", Case#: " + caseNo;
      }

   } else if (layerName === "Flood Zones 2017" && fieldName.Equal("Fld_Zone")) {
      if (fieldValue.StartsWith("A")) {
         outVal += " (High Risk)";

      } else if (fieldValue.StartsWith("V")) {
         outVal += " (High Risk" + '\n' + "Coastal Area)";

      } else if (fieldValue === "D") {
         outVal += " (Undetermined" + '\n' + "Risk)";

      } else {
         outVal += " (Moderate to" + '\n' + "Low Risk)";
      }

      url = "https://www.fema.gov/flood-zones";

   } else if (layerName === "Soils Types") {
      url = "https://www.nrcs.usda.gov/wps/portal/nrcs/main/soils/survey/class/";

   } else if (layerName === "FEMA Firm Panel 2017") {
      if (fieldValue !== "") {
         outVal = fieldValue.substr(0, 6) + " " + fieldValue.substr(6);
      }

   } else if (layerName === "Solid Waste Pickup Days") {
      url = "http://www.augustaga.gov/index.aspx?NID=662";

      //Decode subtypes.
   } else if (layerName === "Zoning" && fieldName.Equal("Description")) {
      if (fieldValue === "A") {
         outVal = "Agriculture";

      } else if (fieldValue === "R-1" || fieldValue === "R-1A" || fieldValue === "R-1B" || fieldValue === "R-1C" || fieldValue === "R-1D" || fieldValue === "R-1E") {
         outVal = "One-Family Residential";

      } else if (fieldValue === "R-2") {
         outVal = "Two-Family Residential";

      } else if (fieldValue === "R-3A" || fieldValue === "R-3B" || fieldValue === "R-3C") {
         outVal = "Multiple-Family Residential";

      } else if (fieldValue === "R-MH") {
         outVal = "Manufactured Home Residential";

      } else if (fieldValue === "PUD") {
         outVal = "Planned Unit Development";

      } else if (fieldValue === "POPD") {
         outVal = "Professional Office Park District";

      } else if (fieldValue === "P-1") {
         outVal = "Professional";

      } else if (fieldValue === "B-1") {
         outVal = "Local Business";

      } else if (fieldValue === "B-2") {
         outVal = "General Business";

      } else if (fieldValue === "LI") {
         outVal = "Light Industry";

      } else if (fieldValue === "HI") {
         outVal = "Heavy Industry";
      }
   }

   return { value: outVal, url: url };
}

//Set custom visibility for field names in point feature layer labels.
export function getCustomLabelFieldNameVisibility(layerName: string, fieldName: string): boolean {
   let visible: boolean = true;
   const trueScale: number = MainMap.mapView.scale;
   const mapScale: number = trueScale / 12;

   //if (fieldName.Equal("Scale")) {
   //   if (mapScale < 0) {
   //      visible = false;
   //   }

   //} else if (fieldName.Equal("OtherField")) {
   //}

   return visible;
}

//Set custom angle for point graphic symbol labels.
export function getCustomLabelAngle(layerName: string, angle: number): number {
   let outAngle: number = angle;
   //outAngle = -angle;
   return outAngle;
}

//Set custom Arcade formatting expression for point feature class labels.
export function getCustomLabelFormatExpression(layerName: string): string {
   let expression: string = null;
   const trueScale: number = MainMap.mapView.scale;
   const mapScale: number = trueScale / 12;

   if (layerName.Equal("Place Names")) {
      if (mapScale < 0) {
         //IIF($feature.POPULATION > 10000, $feature.NAME + ' city', $feature.NAME + ' town')
         //expression = "'Address: ' + $feature.fieldName1 + TextFormatting.NewLine + $feature.fieldName2";
         //expression = "'Address: ' + $feature.scale";
      }

   } else if (layerName.Equal("OtherField")) {

   }

   return expression;
}

//Set custom sql where string for feature layer labels.
export function getCustomLabelQuery(layerName: string): string {
   let sql: string = null;
   const trueScale: number = MainMap.mapView.scale;
   const mapScale: number = trueScale / 12;

   //if (layerName.Equal("Place Names")) {
   //   if (mapScale < 0) {
   //      sql = "scale = 800";
   //   }

   //} else if (layerName.Equal("OtherField")) {
   //}

   return sql;
}

//Set custom visiblity for line and polygon feature layer label values.
export function getCustomLabelVisibility(fieldName: string, fieldValue: any, feature: __esri.Graphic, layerName: string, fs: __esri.FeatureSet): boolean {
   let visible: boolean = true;
   const trueScale: number = MainMap.mapView.scale;
   const mapScale: number = trueScale / 12;

   if (fieldName.Equal("BlaBla")) {
      const totalValue = Util_App.getFieldValueNoCase("totalValue", feature, fs) as number;
      if (totalValue < 300000 && mapScale < 400) {
         visible = false;
      }

   } else if (fieldName.Equal("OtherField")) {
   }

   return visible;
}

//Set custom text value for line and polygon feature layer label values.
export function getCustomLabelValue(fieldName: string, fieldValue: any, feature: __esri.Graphic, layerName: string, fs: __esri.FeatureSet): string {

   //if (fieldName.Equal("pin")) {
   //   fieldValue += " ac";

   //} else if (fieldName.Equal("OtherField")) {
   //}

   return fieldValue as string;
}

//Set custom no value text for community info.
export function getCustomNoValueText(description: string): string {
   let outVal: string = "Not available";

   if (description.Equal("LOMA")) {
      outVal = "None";
   }

   return outVal;
}

//Set custom map tip title html.
export function getCustomMapTipTitleHTML(layerName: string, feature: __esri.Graphic, fs: __esri.FeatureSet): string {
   let html: string = "";
   let pin: string;

   //Parcels.
   if (layerName === "Parcels") {
      pin = Util_App.getFieldValueNoCase("PIN", feature, fs) as string;
      html += '<span style="color: darkred; margin-left: 9px;">' + pin + '</span> ';

   } //End if layername parcels.
   return html;
}

//Set custom map tip content html.
export function getCustomMapTipContentHTML(layerName: string, feature: __esri.Graphic, fs: __esri.FeatureSet): string {
   const html: string = "";

   return html;
}

//Initialize custom layer properties.
export function setLayerProps(layer: any) {
   let sym: any;

   if (layer.id.Equal("Scene Layer Name Here")) {
      sym = {
         type: "mesh-3d",
         symbolLayers: [{
            type: "fill",
            material: { color: "green" },
         }],
      };

      layer.renderer = { type: "simple", symbol: sym, };

   } else if (layer.id.Equal("Polygon Layer Name Here")) {
      sym = { type: "simple-fill", color: [255, 255, 255, 0.2], style: "solid", outline: { color: [0, 180, 255, 1], width: 2 } };
      layer.renderer = { type: "simple", symbol: sym, };

   } else if (layer.id.Equal("Line Layer Name Here")) {
      sym = { type: "simple-line", color: [255, 16, 19, 0.5], width: 5 };
      layer.renderer = { type: "simple", symbol: sym, };

   //} else if (layer.id.Equal("2014 Aerial Photos")) {
   //   const wmtsLayer = layer as __esri.WMTSLayer;
   //   wmtsLayer.activeLayer = new WMTSSublayer({ id: "PICT-OHHOLM14-io4IHWb2CE" });
   //   // { id: "PICT-OHCARR23-p7KCposBYL", tileMatrixSetId: "GoogleMapsCompatible" };
   }
}

//Call custom javascript functions.
export function callFunction(js: string) {
   const sa: string[] = js.replace("js:", "").split("|");
   let sa2: string[];
   const name: string = sa[0].trim();
   let oid: number;
   let layerName: string;
   let featureLayer: __esri.FeatureLayer;
   let attachment: __esri.AttachmentInfo;
   let attachments: __esri.AttachmentInfo;
   let url: string;

   if (name === "showCarousel") {
      if (sa.length > 1) {
         const urls: string[] = sa[1].split(",");
         Carousel.show("Photos and Sketches", urls, 400);
      }

   } else if (name === "showDataTable") {
      if (sa.length > 1) {
         sa2 = sa[1].split(",");
         const title: string = sa2[0].trim();
         const id: string = sa2[1].trim();
         DataTable.show(title, id);
      }

   } else if (name === "showCommunityInfo") {
      if (sa.length > 1) {
         const xy: string[] = sa[1].split(",");
         const x: number = Util.parseFlt(xy[0]);
         const y: number = Util.parseFlt(xy[1]);
         CommunityInfo.setCenterPnt(new Point({ x: x, y: y, spatialReference: MainMap.activeView.spatialReference }));
         DrawerMenu.showTool("Community Information");
      }

   } else if (name === "showSalesSearch") {
      if (sa.length > 1) {
         Search.setActivePIN(sa[1].trim());
         DrawerMenu.showTool("Sales Search");
      }

   } else if (name === "showAttachment") {
      if (sa.length > 1) {
         sa2 = sa[1].split(",");
         layerName = sa2[0].trim();
         oid = Util.parseInteger(sa2[1]);

         featureLayer = Util_App.getLayerById(layerName) as __esri.FeatureLayer;

         if (featureLayer && featureLayer.capabilities.attachment && featureLayer.capabilities.attachment.supportsName) {
            const attachmentQuery = new AttachmentQuery( { objectIds: [oid] });

            featureLayer.queryAttachments(attachmentQuery).then(function (attachments: __esri.AttachmentInfo) {
               if (attachments[oid]) {
                  attachment = attachments[oid][0];
                  url = attachment.url + "/" + attachment.name;
                  window.open(url, "Attachment");
               }

            }).catch(function (error: Error) {
               console.log("attachment query error", error);
            });
         }
      }

   }
}

//Get links.
   function addToLinks(imageType: string, links, inLinks): string[] {
      let url: string;
      let outLinks: string[] = inLinks;

      if (!outLinks) {
         outLinks = [];
      }
      if (links && (links !== "")) {
         const sa: string[] = links.split(",");

         for (const txt of sa) {

            if (imageType === "Picture") {
               url = Settings.webServerURL + "/gappics/" + txt + "/" + txt + ".jpg";

            } else if (imageType === "Sketch") {
               url = Settings.webServerURL + "/sketch_export/" + txt;

            } else {
               url = Settings.webServerURL + "/AugGAgis/GISWebLinks/" + txt;
            }

            outLinks.Add(url);
         }
      }
      return outLinks;
   }

//Add dashes to PIN.
   export function addDashesToPIN(pin: string): string {
      let i: number = 0;
      let c: string;
      let isNumber: boolean = true;
      let outPIN: string = pin;

      if ((pin.length === 10) && (!pin.Contains("-"))) {
         for (i = 0; i < pin.length; i++) {
            c = pin.charAt(i);
            if (!c.IsNumeric()) {
               isNumber = false;
               break;
            }
         }
         if (isNumber) {
            outPIN = pin.substr(0, 3) + "-";
            outPIN += pin.substr(3, 1) + "-";
            outPIN += pin.substr(4, 3) + "-";
            outPIN += pin.substr(7, 2) + "-";
            outPIN += pin.substr(9, 1);
         }
      }
      return outPIN;
   }

//Open a custom link.
export function openLink(toolName: string) {
   let url: string;

   if (toolName === "Contact Us") {
      url = "https://www.augustaga.gov/1956/Contact";
      window.open(url, "ContactUs");

   } else if (toolName === "Home") {
      url = "https://www.augustaga.gov";
      window.open(url, "Home");

   } else if (toolName === "Privacy Policy") {
      window.open(url, "PrivacyPolicy");

   } else if (toolName === "Open Data Hub") {
      url = "https://geohub-augustagis.opendata.arcgis.com/pages/opendata";
      window.open(url, "ExportMap");

   } else if (toolName === "Feedback") {
      url = "https://survey123.arcgis.com/share/3989fe17170d4489ad40bf4707a3dce9";
      window.open(url, "Feedback");
   }
}
